<section id="faq" class="py-5" appScrollReveal>
  <div class="container">
    <h2 class="section-title">FAQs</h2>
    <div class="accordion" id="faqAccordion">
      <div class="accordion-item" *ngFor="let f of faqs; let i = index">
        <h2 class="accordion-header" [id]="'faqHeading'+i">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#faqCollapse'+i" aria-expanded="false" [attr.aria-controls]="'faqCollapse'+i">
            {{f.q}}
          </button>
        </h2>
        <div [id]="'faqCollapse'+i" class="accordion-collapse collapse" [attr.aria-labelledby]="'faqHeading'+i" data-bs-parent="#faqAccordion">
          <div class="accordion-body small">{{f.a}}</div>
        </div>
      </div>
    </div>
  </div>
</section>
